import React from 'react';
import TransferProducts from '../components/product/transfer/index.js';


const TransferProductPage = () => {
	return (
		<TransferProducts />
	)
}

export default TransferProductPage;


// WEBPACK FOOTER //
// ./src/containers/mass-transfer-products-page.js